import { useState, useEffect } from 'react';

import './toast.scss';
import alert from '../../../assets/icons/alert-circle-red.svg' ;


declare function Translate(key: string): string;
declare var _siteSettings: any;
declare var _loginMethodPreRegCheckUrl;

       
const Toast = props => {
    
    var htmlElements;    
    const [messageElements,setMessageElements] = useState([]);
    
    useEffect(() => {             
        if (props.message.includes("*^link")){
            var msgArr: string[] = props.message.split("*");               
            var msgObjArrTmp= [{isLink:false,linkHref:"",text:""}];  

            for (let index = 0; index < msgArr.length; ) {                
                if(msgArr[index] !== ""){
                    if(msgArr[index].startsWith("^")){                                                                         
                        var linkName = msgArr[index].replace("^","");
                        msgObjArrTmp.push({
                                            isLink: true,
                                            linkHref: getEnvUrl(linkName),
                                            text: msgArr[index + 1]
                                        });                       
                        index = index + 2;               
                    }
                    else{                        
                        msgObjArrTmp.push({
                                            isLink: false,
                                            linkHref: "",
                                            text: msgArr[index]
                                        });                        
                        index = index + 1; 
                    } 
                } 
                else{
                    index = index + 1; 
                }          
            }

            htmlElements = msgObjArrTmp.map((item,indx) => {
                if(item.isLink){
                    return (<a href={item.linkHref} key={indx}>{item.text}</a>);
                }
                else{
                    return (<span key={indx}>{item.text}</span>);
                }
            });
            
            setMessageElements(htmlElements);                                    
        }
        else{
            setMessageElements(props.message);
        }
        
    },[]);

    const getEnvUrl = (linkTag:string) =>{
        var targetUrl = Translate("*" + linkTag + "*");
        var targetEnvUrl="";

        switch (targetUrl) {
            case "https://account.gov.il/sspr/public/newuser":
                targetEnvUrl = _siteSettings.signupLink;
                break;
            case "https://account.gov.il/sspr/public/forgottenpassword":
                targetEnvUrl = _siteSettings.forgottenPasswordLink;
                break;
            case "https://login.gov.il/nidp/app/login?id=preRegCheck":
                targetEnvUrl = _loginMethodPreRegCheckUrl;
                break;
            default:
                targetEnvUrl = _siteSettings.signupLink;
                break;
        }

        return targetEnvUrl;
    };
           

    return (
        <div id='errorMessageContainer' className="toast-error"> 
            <span className='bstrp-m-2'>
                <img src={alert} />
            </span>
            <div id='errorMessage' className='errorMessageCover'>
                <div>{messageElements}</div>                          
            </div>
        </div>
    )

        
};
export default Toast;
